import { useHistory } from 'react-router-dom';

import { NsCta } from 'components/common/ns-cta/NsCta';

export const NsBackCta = () => {
  const history = useHistory();

  const onBackBtnClick = () => {
    history.goBack();
  };

  return (
    <span>
      <NsCta type="text" icon="arrow-left" onClick={onBackBtnClick}>
        Back
      </NsCta>
    </span>
  );
};
